export default __webpack_public_path__ + "static/media/star.a12d58bf.svg";